import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import MenuVariaveis from '../../MenuVariaveis';

export default (props) => {
  const { doUpdateItem, item, answerHandlerOpen } = props;

  const [ZendeskSettings, setZendeskSettings] = useState({
    email: '',
    password: '',
    requestId: '',
  });

  useEffect(() => {
    if (item && item.zendesk) {
      setZendeskSettings(item.zendesk);
    }
  }, [item]);

  const { i18n } = useTranslation();

  const handleInputSettingsChange = (e) => {
    const { name, value } = e.target;
    const updatedSettings = { ...ZendeskSettings, [name]: value };

    setZendeskSettings(updatedSettings);
    doUpdateItem({ zendesk: updatedSettings });
  };

  const handleSelectVariavel = (name, value, variavel) => {
    const newValue = `${value}${variavel}`;
    const updatedSettings = { ...ZendeskSettings, [name]: newValue };

    setZendeskSettings(updatedSettings);
    doUpdateItem({ zendesk: updatedSettings });
  };

  return (
    <>
      <p className="handler-title">Finalizar Ticket</p>

      <MenuVariaveis
        onSelect={(variavel) =>
          handleSelectVariavel('email', ZendeskSettings.email, `{${variavel}}`)
        }
        buttonRight="27px"
        buttonBottom="25px"
        id={`bloco-${item._id}-configuracao-email`}
        isTooltip
        hidden={answerHandlerOpen}
      >
        <div className="common-form-group">
          <label>{i18n.t('E-mail')}</label>
          <input
            className="form-control mt-1"
            value={ZendeskSettings.email || ''}
            name="email"
            onChange={(e) => handleInputSettingsChange(e)}
          />
        </div>
      </MenuVariaveis>

      <MenuVariaveis
        onSelect={(variavel) =>
          handleSelectVariavel(
            'password',
            ZendeskSettings.password,
            `{${variavel}}`
          )
        }
        buttonRight="27px"
        buttonBottom="25px"
        id={`bloco-${item._id}-configuracao-password`}
        isTooltip
        hidden={answerHandlerOpen}
      >
        <div className="common-form-group">
          <label>{i18n.t('Senha')}</label>
          <input
            className="form-control mt-1"
            value={ZendeskSettings.password || ''}
            name="password"
            onChange={(e) => handleInputSettingsChange(e)}
          />
        </div>
      </MenuVariaveis>

      <MenuVariaveis
        onSelect={(variavel) =>
          handleSelectVariavel(
            'requestId',
            ZendeskSettings.requestId,
            `{${variavel}}`
          )
        }
        buttonRight="27px"
        buttonBottom="25px"
        id={`bloco-${item._id}-configuracao-requestId`}
        isTooltip
        hidden={answerHandlerOpen}
      >
        <div className="common-form-group">
          <label>{i18n.t('Id do Ticket')}</label>
          <input
            className="form-control mt-1"
            value={ZendeskSettings.requestId || ''}
            name="requestId"
            onChange={(e) => handleInputSettingsChange(e)}
          />
        </div>
      </MenuVariaveis>
    </>
  );
};
